import dogPlaying from "./assets/images/dog-playing-svgrepo-com.svg";

export default function NoPetsFound() {
  return <div className="text-center text-gray-500 font-medium">
    <span className="text-2xl text-gray-700">No pets found.</span>
    <br/>
    <img src={dogPlaying} className="mx-auto w-[100px] h-auto"/>
    <br/>
    Try changing the search filters.
  </div>
}